import React from 'react';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CloseIconStyled, MuiDialogStyled } from 'app/components/Dialog/Dialog.styles';
import { ActionButton } from 'app/components';
import { TranslationKeys } from 'app/translations';

type OwnerListDialogProps = {
  open: boolean;
  title: React.ReactElement | string;
  onClose: () => void;
  children: React.ReactNode;
};

export const OwnerListDialog = ({ open, title, onClose, children }: OwnerListDialogProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <MuiDialogStyled open={open} onClose={onClose} maxWidth="sm" scroll="paper" fullWidth fullScreen={fullScreen}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <MuiDialogTitle variant="h5">{title}</MuiDialogTitle>
        <CloseIconStyled onClick={onClose} />
      </Box>

      <MuiDialogContent sx={{ paddingRight: 0 }}>{children}</MuiDialogContent>

      <MuiDialogActions sx={{ padding: theme.spacing(2) }}>
        <ActionButton onClick={onClose} messageId={TranslationKeys.close} />
      </MuiDialogActions>
    </MuiDialogStyled>
  );
};
